import { gql } from "graphql-tag";

const QUERY_MANUALS_LIST_FOR_SITEID = gql`
  query ManualsListForSite($siteId: [QueryArgument]) {
    manualsList: entries(
      section: ["manuals", "manualsComposableEntries"]
      siteId: $siteId
      type: ["product"]
      status: ["enabled"]
    ) {
      id
      siteId
      siteHandle
      uid
      enabled
      archived
      status
      uri
      title
      typeHandle
      ... on product_Entry {
        id
        title
        userTitle
        enabledForSite
        typeHandle
        productFamily
        productVariant
        productCategory {
          id
          title
          ... on productCategories_Category {
            id
            role
          }
        }
        productIcon {
          uid
          url
          height
          width
        }
      }
    }
  }
`;
export default QUERY_MANUALS_LIST_FOR_SITEID;
